<template>
	<div class="nlist_page">
		<div class="nlist_wrap">
			<div class="nlist_con">
				<div class="ncon_left">
					<p class="ncon_left_tit">新闻资讯</p>
					<ul class="ncon_left_ul">
						<li class="ncon_left_li" @click="handNav(30,'最新资讯')">
							<span :class="nname == '最新资讯' ? 'nlact' : ''">最新资讯</span>
							<i :class="nname == '最新资讯' ? 'nlact' : ''" class="ar_right el-icon-arrow-right"></i>
						</li>
						<li class="ncon_left_li" @click="handNav(31,'公告公示')">
							<span :class="nname == '公告公示' ? 'nlact' : ''">公告公示</span>
							<i :class="nname == '公告公示' ? 'nlact' : ''" class="ar_right el-icon-arrow-right"></i>
						</li>
					</ul>
				</div>
				<div class="ncon_right">
					<ul class="nrt_ul">
						<li class="nrt_li" v-for="(item, index) in dataList" :key="index">
							<div class="nrt_li_left">
								<p class="nrt_li_left_p1">{{ item.nianyue }}</p>
								<p class="nrt_li_left_p2">{{ item.ri }}</p>
							</div>
							<div class="nrt_li_right">
								<p class="nrt_li_right_p1">
									{{ item.title }}
								</p>
								<p class="nrt_li_right_p2">
									{{ item.summary }}
								</p>
								<p class="nrt_li_right_p3" @click="toDetail(item)">阅读详情</p>
							</div>
						</li>
						<div class="fenye">
							<pagination1 :total-pages="totalPage" :total-num="totalNum" :current-page="currentPage"
								@page-change="handlePageChange" />
						</div>
					</ul>
				</div>
			</div>
			<div class="record_box">
				<record></record>
			</div>
		</div>
	</div>
</template>

<script>
import pagination1 from "../../components/pagination1.vue";
export default {
	components: {
		pagination1,
	},
	data() {
		return {
			nid: "",
			nname: "",
			dataList: [],
			currentPage: 1,
			totalPage: 0,
			totalNum: 0,
		};
	},
	watch: {
		$route(to, from) {
			this.nid = this.$route.query.id;
			this.nname = this.$route.query.name;
			this.newslist();
			this.$forceUpdate();
		},
	},
	created() {
		this.nid = this.$route.query.id;
		this.nname = this.$route.query.name;
		this.newslist();
		this.$forceUpdate();
	},
	methods: {
		// 新闻列表
		async newslist() {
			var data2 = {
				typeid: this.nid,
				page: this.currentPage - 1,
				nums: 10,
			};
			const res = await this.$api.newslist(data2);
			if (res.code == 1) {
				this.totalNum = res.msg;
				this.totalPage = Math.ceil(Number(this.totalNum) / 10);
				if (res.data.length) {
					this.dataList = res.data;
					for (let i = 0; i < this.dataList.length; i++) {
						var nyr = this.dataList[i].publishtime.split("-");
						this.dataList[i].nianyue = nyr[0] + "." + nyr[1];
						this.dataList[i].ri = nyr[2];
					}
				}
			} else {
				this.dataList = [];
			}
		},
		handlePageChange(newPage) {
			this.currentPage = newPage;
			this.newslist();
		},
		toDetail(item) {
			this.$router.push("/newsDetail?xid=" + item.id + '&typeid=' + item.typeid);
		},
		handNav(id, name) {
			this.nid = id;
			this.nname = name;
			this.newslist();
			this.$forceUpdate();
		}
	},
};
</script>

<style lang="scss">
.nlact {
	color: #d43235 !important;
}
.nlist_page {
    @font-face {
        font-family: 'SourceHanSans';
        src: url('../../font/SourceHanSansCN-Regular.otf');
    }
    font-family: 'SourceHanSans';
	margin-top: 76px;
	background-image: url("../../images/bgimg3.png");
	padding: 40px 0 80px;
	.nlist_wrap {
		max-width: 1324px;
		min-width: 950px;
		margin: 0 auto;
		padding: 0 20px;
		.nlist_con {
			padding-bottom: 76px;
			display: flex;
			align-items: flex-start;
			.ncon_left {
				width: 270px;
				background-color: #fff;
				padding: 26px 20px 180px;
				background-image: url("../../images/news/nbmg1.png");
				background-repeat: no-repeat;
				background-size: 100% auto;
				background-position: bottom;
				border-radius: 6px;
				.ncon_left_tit {
					position: relative;
					color: #000;
					font-size: 20px;
					border-bottom: 3px solid #dedddc;
					padding-bottom: 17px;
					text-align: left;
					&::after {
						content: "";
						position: absolute;
						left: 0;
						bottom: -3px;
						height: 3px;
						width: 40px;
						background-color: #d43235;
					}
				}
				.ncon_left_ul {
					padding-top: 10px;
					.ncon_left_li {
						border-bottom: 1px solid #ececec;
						display: flex;
						justify-content: space-between;
						align-items: center;
						cursor: pointer;
						span {
							color: #333;
							font-size: 16px;
							background-repeat: no-repeat;
							display: block;
							background-position: 100%;
							padding: 16px 0;
						}
						.ar_right {
							font-size: 18px;
							color: #ccc;
							font-weight: 500;
						}
					}
				}
			}
			.ncon_right {
				overflow: hidden;
				padding-left: 80px;
				flex: 1;
				.nrt_ul {
					padding-bottom: 75px;
					.nrt_li {
						padding: 30px 0;
						border-bottom: 1px solid #ccc;
						display: flex;
						justify-content: space-between;
						.nrt_li_left {
							width: 100px;
							height: 100px;
							border-radius: 5px;
							border: 1px solid #ccc;
							float: left;
							text-align: center;
							color: #828282;
							font-size: 16px;
							padding-top: 15px;
							box-sizing: border-box;
							.nrt_li_left_p2 {
								font-size: 38px;
							}
						}
						.nrt_li_right {
							flex: 1;
							overflow: hidden;
							padding-left: 40px;
							.nrt_li_right_p1 {
								color: #000;
								font-size: 20px;
								overflow: hidden;
								text-overflow: ellipsis;
								white-space: nowrap;
								position: relative;
								padding-bottom: 30px;
								margin-bottom: 14px;
								text-align: left;
								&::after {
									content: "";
									position: absolute;
									left: 0;
									bottom: 0;
									background-color: #bebebe;
									width: 100px;
									height: 2px;
								}
							}
							.nrt_li_right_p2 {
								color: #828282;
								font-size: 16px;
								line-height: 1.7;
								margin-bottom: 28px;
								text-align: left;
							}
							.nrt_li_right_p3 {
								color: #fff;
								font-size: 16px;
								background-color: #d43235;
								width: 100px;
								height: 38px;
								text-align: center;
								line-height: 38px;
								border-radius: 5px;
								cursor: pointer;
							}
						}
					}
					.fenye {
						margin-top: 60px;
					}
				}
			}
		}
	}
}
</style>